$(document).ready(function () {
    $("#table-roles").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'get-roles',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'name', name: 'name'},
        ],
        "columnDefs": [{
            "targets": 2,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                return '<button data-toggle="tooltip" data-placement="top" title="Asignar permisos al rol" class="btn button_almadia ' +
                    'check-permissions btn-sm"' +
                    'data-name ="' + row.name + '"' +
                    'data-rol ="' + row.id + '"  ><i class="fas fa-list-ul"></i></button>'
            }
        }]

    });
    const list_roles = $("#table-roles").DataTable()

    $("#add-rol").on('click', function (e) {
        e.preventDefault()
        $("#form-roles")[0].reset()
        $(".item-id").val('');
        $("#modal-title-rol").text('Nuevo rol')
        $("#modal-roles").modal('show')
    })

    $("#form-roles").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $(".loader_").addClass("loading")
        sendData(data, '/admin/data-rol', 'modal-roles')
    })

    $("#table-roles tbody").on('click', '.check-permissions', function (e) {
        e.preventDefault()
        let rol_id = $(this).data('rol');
        let data = new FormData()
        let if_check = ""
        $(".title-rol").text($(this).data('name'))
        $('.list-roles-permissions').empty()
        data.append('rolId', $(this).data('rol'))
        $.ajax({
            url: "/admin/roles/get-permission-by-rol",
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (list) {
                $(".item-id").val(rol_id)
                $("#modal-roles-permissions").modal('show')
                for (var i = 0; i < list.length; i++) {
                    var checked = list[i].inRol === "true" ? "checked" : ""
                    $(".list-group").append("" +
                        "<li class='list-group-item m-1'>" +
                        "<label><input data-check ="+ list[i].id +" type='checkbox' " + checked + " class='m-1'>" +
                        "" + list[i].name + "</label></li>")
                }
            }
        })
    })

    $(".list-group").on("click", "input[type='checkbox']", function() {
        $(".loader_").addClass("loading")
        $.ajax({
            type: "POST",
            url: "/admin/update-permission-by-rol",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                permissions:$(this).data('check'),
                rol:$(".item-id").val(),
            },
            success: function(response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.type == "success") {
                        alertSuccess(response.msg)
                    } else {
                        alertError(response.msg)
                    }
                }, 1000)
            },
            error: function(error) {
                alertError("Error al realizar la petición")
            }
        });
    });

    function sendData(data, route, modal) {
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                        $("#table-roles").DataTable().ajax.reload();
                        $("#modal-roles").modal("hide")
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }

})
